import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Typography from '../../../components/overrides/Typography';
import {
  SEARCH_RESULT_NO_RESULT_PREFIX,
  SEARCH_RESULT_NO_RESULT_JOIN,
  NO_SEARCH_RESULT_DESCRIPTION,
  NO_SEARCH_RESULT_CLEAR_CTA,
} from '../../../assets/copy';
import { Button } from '../../../components/spoon/Button';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  customButton: {
    marginTop: '27px',
    width: '172.5px',
    padding: '9px 16px 11px 16px',
    fontSize: '14px',
    lineHeight: '20px',
    borderRadius: '12px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '12px',
    },
  },
  descriptionText: {
    paddingTop: '4px',
    color: theme.palette.spoon.black[100],
  },
}));

const LocalMarketEmpty = ({ clearSearchFunction }) => {
  const classes = useStyles();

  const { currentQuery: searchQuery } = useSelector((state) => state.search);
  const { name: marketName } = useSelector((state) => state.markets.market);

  return (
    <div>
      <Typography variant="medium2Light">
        {SEARCH_RESULT_NO_RESULT_PREFIX +
          searchQuery +
          SEARCH_RESULT_NO_RESULT_JOIN +
          marketName}
      </Typography>
      <Typography variant="small3Normal" className={classes.descriptionText}>
        {NO_SEARCH_RESULT_DESCRIPTION}
      </Typography>
      <Button
        classes={{ root: classes.customButton }}
        onClick={clearSearchFunction}>
        {NO_SEARCH_RESULT_CLEAR_CTA}
      </Button>
    </div>
  );
};

export default LocalMarketEmpty;
